"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrencyForCode = getCurrencyForCode;
exports.getFormattedPrice = getFormattedPrice;

var _useCurrency2 = _interopRequireDefault(require("../../hooks/useCurrency"));

var _CurrencyInformation = _interopRequireDefault(require("../../models/CurrencyInformation/CurrencyInformation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getCurrencyFromCurrencies(currencies, code) {
  return currencies.find(function (currency) {
    return currency.code === code;
  });
}

function getCurrencyForCode(code) {
  var nativeCurrencyCode = _CurrencyInformation["default"].nativeCurrencyCode,
      bookableCurrencies = _CurrencyInformation["default"].bookableCurrencies,
      nonBookableCurrencies = _CurrencyInformation["default"].nonBookableCurrencies;
  var isNativeCurrency = code === nativeCurrencyCode;
  var currency;
  currency = getCurrencyFromCurrencies(bookableCurrencies, code);
  var isBookableCurrency = Boolean(currency);
  currency = currency ? currency : getCurrencyFromCurrencies(nonBookableCurrencies, code);
  return _objectSpread({}, currency, {
    isNativeCurrency: isNativeCurrency,
    isBookableCurrency: isBookableCurrency
  });
}

function getFormattedPrice(price, hasCents) {
  var _useCurrency = (0, _useCurrency2["default"])(),
      code = _useCurrency.code,
      locale = _useCurrency.locale;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
    minimumFractionDigits: !hasCents ? 0 : 2,
    maximumFractionDigits: !hasCents ? 0 : 3
  }).format(price);
}